import { Link, MessageDetail } from "@relode/core";
import React from "react";

export function messageTitleFactory(message: MessageDetail) {
    if (!message) return null;
    const { jobId, jobName, leadId, leadName, hasJobAccess } = message;

    const LeadTitle = () =>
        hasJobAccess ? (
            <Link
                data-cy="leadTitle"
                gutterBottom={false}
                to={{
                    pathname: `/candidates/${jobId}/${leadId}`,
                    state: { backUrl: `/messages/${message.messageId}` },
                }}
            >
                {leadName}
            </Link>
        ) : (
            <>{leadName}</>
        );

    const JobTitle = () =>
        hasJobAccess ? (
            <Link
                data-cy="jobTitle"
                gutterBottom={false}
                to={{
                    pathname: `/jobs/${jobId}`,
                    state: { backUrl: `/messages/${message.messageId}` },
                }}
            >
                {jobName}
            </Link>
        ) : (
            <>{jobName}</>
        );

    if (!!jobId && !!leadId) {
        return (
            <span>
                <LeadTitle data-cy="leadTitle" /> - <JobTitle />
            </span>
        );
    }

    if (!!jobId) return <JobTitle />;

    return null;
}
